import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatSnackBar} from '@angular/material';
import {CustomerService} from '../../services/customer.service';
import {SharedService} from '../../services/shared.service';

@Component({
  selector: 'app-code-verification-dialog',
  templateUrl: './code-verification-dialog.component.html',
  styleUrls: ['./code-verification-dialog.component.scss']
})
export class CodeVerificationDialogComponent implements OnInit {
  code: string;
  phone: string;
  showLoader: boolean;
  verificationCodeMask = [/\d/, /\d/, /\d/, /\d/];

  constructor(public dialogRef: MatDialogRef<CodeVerificationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private customerService: CustomerService,
              private shared: SharedService,
              private snackBar: MatSnackBar) {
    this.phone = data.phone;
  }

  sendCode(code: string) {
    this.dialogRef.close({code: code});
  }

  resendCode() {
    this.showLoader = true;
    this.customerService.sendSms('+1', this.phone)
      .then(() => {
        this.code = null;
        this.showLoader = false;
        this.snackBar.open('Code sent', null, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      })
      .catch(err => {
        this.showLoader = false;
        this.dialogRef.close();
        this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error. Please try again'});

      });
  }

  ngOnInit() {
  }

}
